import React from "react";
import { Col, Row } from "antd";

import type { RowProps, ColProps } from "antd/lib";

interface TypeRowsProps
  extends Pick<RowProps, "gutter">,
    Pick<ColProps, "span"> {
  children?: React.ReactNode;
  className?: string;
  /**
   * @param colHeight Col组件高度
   */
  colHeight?: number;
  /**
   * @param colHeightCenter 每个组件上下居中
   */
  colHeightCenter?: boolean;
}

/**
 * @name Rows 简化 Row、Col 配置
 * @description gutter 默认24 span 默认8，方便Form表单布局
 */
const Rows: React.FC<TypeRowsProps> = ({
  children,
  className,
  span = 8,
  gutter = 24,
  colHeight,
  colHeightCenter,
}) => (
  <Row gutter={gutter} className={`layout-rows-arrange ${className || ""}`}>
    {React.Children.map(
      Array.isArray(children) ? children.filter(Boolean) : children, // children可以是 element数组 也可以是单个element
      (child: React.ReactNode & { props: ColProps }) => (
        <Col
          style={{
            height: colHeight,
            display: colHeightCenter ? "flex" : undefined,
            alignItems: colHeightCenter ? "center" : undefined,
          }}
          flex={child.props?.labelCol?.flex}
          span={child.props?.labelCol?.span || span}
        >
          {child}
        </Col>
      ),
    )}
  </Row>
);

export default Rows;
